import React, { Fragment } from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { observer } from 'mobx-react-lite';
import { toggleModalPop } from '@store/actions/modal';
import TicketMigrationModal from '../TicketsMigration/List/components/TicketMigrationModal';
import WeeklyReportGenerateModal from '@vcomponents/Dashboard/reports/WeeklyReportGenerateModel';
import JobHistoryModal from '@vcomponents/Jobs/JobHistoryModal';
import JobDetailsModal from '@vcomponents/Jobs/JobDetailsModal';
import  JobSupervisorModal from '@vcomponents/Jobs/JobSupervisorModal';
import './style.scss';

const AppModal = observer(() => {
  const { show, modalName, title, payload } = useSelector(
    (state) => state.modal
  );

  const dispatch = useDispatch();

  const toggleModal = () => {
    dispatch(toggleModalPop());
  };

  return (
    <Fragment>
      <Modal isOpen={show} toggle={toggleModal} className='app-modal' size="lg">
        <ModalHeader toggle={toggleModal} className='align-items-center'>
          {title}
        </ModalHeader>

        {modalName === 'JOB_HISTORY_MODAL' && (
          <JobHistoryModal />
        )}
         {modalName === 'JOB_DETAIL_MODAL' && (
          <JobDetailsModal />
        )}
        {modalName === 'JOB_SUPERVISOR_MODAL' && (
          <JobSupervisorModal />
        )}
        {modalName === 'MIGRATION_MODAL' && <TicketMigrationModal />}
        {modalName === 'REPORTS_MODAL' && <WeeklyReportGenerateModal />}
      </Modal>
    </Fragment>
  );
});

export default AppModal;
